module.exports = __webpack_public_path__ + "public/images/ballet.1bd63170398cb178b113a2d8fe215ed8.jpg";